import React from 'react';

import ShopNotesMultiParagraphText from './ShopNotesMultiParagraphText';
import ShopNotesSingleParagraphText from './ShopNotesSingleParagraphText';

interface Props {
  text: string;
}

const ShopNotesText = ({ text }: Props) => {
  const isMultiParagraph = text?.includes('\n');

  return (
    <>
      {!isMultiParagraph && <ShopNotesSingleParagraphText text={text} />}
      {isMultiParagraph && <ShopNotesMultiParagraphText text={text} />}
    </>
  );
};

export default ShopNotesText;
